module.exports = __webpack_public_path__ + "static/media/redes_icons-03.bc51d2e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/redes_icons-03.png
// module id = 147
// module chunks = 0